import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { AutocompleteItemWrapper, ItemIcon, AutocompleteItemText } from "@similarweb/ui-components";

import { LEFT_DISTANCE } from "app/pages/sales-intelligence/modules/company-autocomplete/components/DomainAutocompleteItem/styles";

export const StyledAutocompleteCompanyWrapper = styled(AutocompleteItemWrapper)<{
    isCollapsed: boolean;
    isDisabled?: boolean;
}>`
    position: relative;
    padding: 8px 16px 8px 8px;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

    &::after {
        content: "";
        display: block;
        position: absolute;
        left: ${LEFT_DISTANCE}px;
        width: 1px;
        height: 50%;
        bottom: ${({ isCollapsed }) => (isCollapsed ? "8px" : 0)};
        transition: ${({ isCollapsed }) => (isCollapsed ? "bottom 0s 0.3s linear" : "none")};
        background-color: ${colorsPalettes.carbon[100]};
    }
`;
export const StyledAutocompleteIconContainer = styled.div`
    position: relative;
    padding: 8px;

    ${SWReactIcons} {
        width: 13px;
        height: 13px;
    }
`;

export const StyledAutocompleteItemIcon = styled(ItemIcon)`
    flex: none;
    z-index: 1;
`;

export const StyledAutocompleteItemTextWrapper = styled.div`
    overflow: hidden;
`;

export const StyledAutocompleteItemText = styled(AutocompleteItemText)<{ isDisabled?: boolean }>`
    ${mixins.truncateText()};
    color: ${({ isDisabled }) => (isDisabled ? colorsPalettes.carbon[250] : colorsPalettes.carbon[500])};
`;

export const StyledAutocompleteDomainsList = styled.div<{ isCollapsed: boolean }>`
    max-height: ${({ isCollapsed }) => (isCollapsed ? 0 : "8000px")};
    overflow: hidden;
    transition: max-height 0.3s ease-out;
`;
